<template>
  <vxe-modal ref="modal" v-model="formVisible" :title="modalTitle" :width="isMobile ? '80%' : '400px'">
    <el-form size="mini">
      <el-form-item :label="`${modalTitle}意见`">
        <el-input type="textarea" placeholder="输入" :rows="5" v-model="ApprovalOpinions" />
      </el-form-item>
    </el-form>

    <div style="display: flex;justify-content: flex-end" v-if="!isMobile">
      <el-button @click="closeModal()">取消</el-button>
      <el-button type="primary" @click="confirm()">确认</el-button>
    </div>

    <div style="width: 100%" v-else>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-button style="width: 100%" @click="closeModal()">取消</el-button>
        </el-col>
        <el-col :span="12">
          <el-button type="primary" style="width: 100%" @click="confirm()">确认</el-button>
        </el-col>
      </el-row>
    </div>
  </vxe-modal>
</template>
<script>
export default {
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    modalTitle: {
      type: String,
      default: '审批'
    }
  },
  data() {
    return {
      formVisible: false,
      ApprovalOpinions: ''
    }
  },
  methods: {
    openModal() {
      this.ApprovalOpinions = ''

      this.formVisible = true
    },
    closeModal() {
      this.formVisible = false
    },
    confirm() {
      this.$emit('sureBack', this.ApprovalOpinions)
    }
  }
}
</script>
<style lang="less" scoped></style>
